@file:OptIn(InternalResourceApi::class)

package top.features.dashboard.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.features.dashboard.generated.resources/"

@delegate:ResourceContentHash(-1_155_651_148)
internal val Res.string.nav_ai_moderation: StringResource by lazy {
      StringResource("string:nav_ai_moderation", "nav_ai_moderation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 77),
      ))
    }

@delegate:ResourceContentHash(1_234_100_074)
internal val Res.string.nav_dashboard: StringResource by lazy {
      StringResource("string:nav_dashboard", "nav_dashboard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88, 57),
      ))
    }

@delegate:ResourceContentHash(-980_793_275)
internal val Res.string.nav_moderators: StringResource by lazy {
      StringResource("string:nav_moderators", "nav_moderators", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146, 50),
      ))
    }

@delegate:ResourceContentHash(1_278_691_946)
internal val Res.string.nav_review: StringResource by lazy {
      StringResource("string:nav_review", "nav_review", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197, 38),
      ))
    }

@delegate:ResourceContentHash(-1_900_156_030)
internal val Res.string.nav_settings: StringResource by lazy {
      StringResource("string:nav_settings", "nav_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236, 52),
      ))
    }

@delegate:ResourceContentHash(1_574_118_056)
internal val Res.string.nav_team: StringResource by lazy {
      StringResource("string:nav_team", "nav_team", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289, 36),
      ))
    }

@delegate:ResourceContentHash(452_736_541)
internal val Res.string.nav_users: StringResource by lazy {
      StringResource("string:nav_users", "nav_users", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326, 49),
      ))
    }

@delegate:ResourceContentHash(1_100_651_364)
internal val Res.string.nav_venues: StringResource by lazy {
      StringResource("string:nav_venues", "nav_venues", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 376, 38),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("nav_ai_moderation", Res.string.nav_ai_moderation)
  map.put("nav_dashboard", Res.string.nav_dashboard)
  map.put("nav_moderators", Res.string.nav_moderators)
  map.put("nav_review", Res.string.nav_review)
  map.put("nav_settings", Res.string.nav_settings)
  map.put("nav_team", Res.string.nav_team)
  map.put("nav_users", Res.string.nav_users)
  map.put("nav_venues", Res.string.nav_venues)
}
